import env from 'configuration'
import { useAgency } from 'context/agency'
import { AuthInit } from 'context/auth'
import { LocationInit } from 'context/location'
import useScript from 'hooks/script'
import { useEffect } from 'react'
import { useRoutes } from 'react-router-dom'
import Routes from 'routing/routes'
import { setGHLSessionKey, setSSO } from 'utils/auth-helper'

function App() {
  const routes = useRoutes(Routes())
  const { agency } = useAgency()
  const scriptLoaded = useScript(
    `https://maps.googleapis.com/maps/api/js?key=${env.G_MAP_API_KEY}&loading=async&libraries=places`
  )

  const bg_color = agency?.location_config?.page_bg_color

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const sessionkey = queryParams.get('sessionkey')

    if (sessionkey) setGHLSessionKey(sessionkey)
  }, [])

  return (
    <div
      style={{
        backgroundColor: bg_color,
      }}
      className='h-screen overflow-y-auto relative'
    >
      <AuthInit>
        <LocationInit>{routes}</LocationInit>
      </AuthInit>
    </div>
  )
}

export default App
